<mat-card appearance="outlined" *appRoles="['Tareas.Listar']">
  <mat-card-header>
    <div class="header-nombre-nuevo">
      <h2>Tareas</h2>
      <app-button-new *appRoles="['Tareas.Crear']"
        (click)="openDialog({ accion: accionesDialog.Agregar, entidad: {idExpediente} })"></app-button-new>
    </div>
  </mat-card-header>
  <mat-card-content>
    <form [formGroup]="formFilter">
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Titulo</mat-label>
            <input matInput type="text" maxlength="200" formControlName="Titulo" />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <ngx-spinner [zIndex]="-1" name="spTipoTarea" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Tipo</mat-label>
            <mat-select multiple placeholder="Seleccione opcion" formControlName="IdsTipoTarea">
              <mat-option [value]="tipoTarea.id" *ngFor="let tipoTarea of tiposTarea">
                {{ tipoTarea.descripcion }}</mat-option>
            </mat-select>
            <mat-error *ngIf="formFilter.controls['IdsTipoTarea'].hasError('required')">Este campo es
              <strong>requerido</strong>.</mat-error>
          </mat-form-field>
        </div>

        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <ngx-spinner [zIndex]="-1" name="spEstadoTarea" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Estado</mat-label>
            <mat-select multiple placeholder="Seleccione opcion" formControlName="IdsEstadoTarea">
              <mat-option [value]="estadoTarea.id" *ngFor="let estadoTarea of estadosTarea">
                {{ estadoTarea.descripcion }}</mat-option>
            </mat-select>
            <mat-error *ngIf="formFilter.controls['IdsEstadoTarea'].hasError('required')">Este campo es
              <strong>requerido</strong>.</mat-error>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Prioridad </mat-label>
            <mat-select multiple placeholder="Seleccione opcion" formControlName="Prioridad">
              <mat-option [value]="prioridad.id" *ngFor="
                  let prioridad of lstPrioridades;
                  let i = index;
                  trackBy: trackByItems
                ">
                {{ prioridad.descripcion }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline">
            <mat-label>Rango de fecha</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input matStartDate formControlName="FechaAltaDesde" placeholder="Fecha desde" />
              <input matEndDate formControlName="FechaAltaHasta" placeholder="Fecha hasta" />
            </mat-date-range-input>
            <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </div>


        <div class="col" *ngIf="checkedFiltroAvanzado">
          <app-select-usuarios-empresa [label]="'Creado por'"
            (usuarioSeleccionado)="onCreadoPorSeleccionado($event)"></app-select-usuarios-empresa>
        </div>

        <div class="col" *ngIf="checkedFiltroAvanzado">
          <app-select-usuarios-empresa [label]="'Modificado por'"
            (usuarioSeleccionado)="onAprobadoPorSeleccionado($event)"></app-select-usuarios-empresa>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-auto">
          <div style="display: flex; align-items: center; gap: 8px;">
            <app-button-filter-table (click)="aplicarFiltro()"></app-button-filter-table>
            <app-button-filter-table-clear (click)="limpiarFiltro()"></app-button-filter-table-clear>
          </div>

        </div>
        <div class="col-auto">
          <mat-slide-toggle (change)="filtrosAvanzados($event)" color="primary">
            Filtros Avanzados
          </mat-slide-toggle>
        </div>
      </div>
    </form>
  </mat-card-content>

  <mat-card-content>
    <mat-divider></mat-divider>
    <ngx-spinner [zIndex]="100" name="spListado" bdColor="rgba(255,255,255,0.8)" size="default"
      color="var(--primary-color)" type="ball-atom" [fullScreen]="false"></ngx-spinner>

    <!-- Inicio Contenedor acciones tabla -->
    <div class="contenedor-acciones-tablas">
      <div class="acciones-tabla">
        <!-- Boton de Acciones -->


        <div class="col-auto">
          <mat-slide-toggle [checked]="esVistaTabla" *ngIf="data" (change)="cambiarVista($event)" color="primary">
            Cambiar vista
          </mat-slide-toggle>
        </div>
      </div>
      <mat-form-field appearance="outline" *ngIf="esVistaTabla && data" class="buscador-tabla">
        <mat-icon matPrefix>search</mat-icon>
        <mat-label>Buscar</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Buscar" #input />
      </mat-form-field>
    </div>
    <!-- Fin Contenedor acciones tabla -->


    <div>
      <div *ngIf="!esVistaTabla">
        <app-tablero-kanban  (emitirGenerarListado)="aplicarFiltro()" *ngIf="listadoTareas" [listadoTareas]="listadoTareas"></app-tablero-kanban>
      </div>
      <div *ngIf="esVistaTabla">
        <table class="mat-elevation-z8" mat-table [dataSource]="dataSource" *ngIf="data" matSort matSortStart="asc">
          <ng-container matColumnDef="titulo">
            <mat-header-cell *matHeaderCellDef mat-sort-header><strong>Título</strong></mat-header-cell>
            <mat-cell *matCellDef="let tarea"><span>{{ tarea.titulo | titlecase }}</span></mat-cell>
          </ng-container>

          <ng-container matColumnDef="tipoTarea">
            <mat-header-cell *matHeaderCellDef mat-sort-header><strong>Tipo</strong></mat-header-cell>
            <mat-cell *matCellDef="let tarea"><span>{{ tarea.tipoTarea?.descripcion | titlecase }}</span></mat-cell>
          </ng-container>

          <!-- <ng-container matColumnDef="expediente">
        <mat-header-cell *matHeaderCellDef mat-sort-header><strong>Expediente</strong></mat-header-cell>
        <mat-cell *matCellDef="let tarea">
          <div *ngIf="tarea.expediente">
            <a [routerLink]="'/expedientes/' + tarea.expediente.id">
              <span>{{ tarea.expediente.caratula | uppercase }}</span>
            </a>
          </div>
        </mat-cell>
      </ng-container> -->

          <ng-container matColumnDef="fechaAlta">
            <mat-header-cell *matHeaderCellDef mat-sort-header><strong>Fecha creación</strong></mat-header-cell>
            <mat-cell *matCellDef="let tarea"><span>{{ tarea.fechaAlta | date: "short" }}</span></mat-cell>
          </ng-container>

          <ng-container matColumnDef="nivelAvance">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              <strong>Nivel Avance</strong>
            </mat-header-cell>
            <mat-cell *matCellDef="let tarea">
              <span class="avance-container" [ngClass]="{
              'avance-bajo': tarea.nivelAvance == 1,
              'avance-medio': tarea.nivelAvance == 2,
              'avance-alto': tarea.nivelAvance == 3
            }">
                <mat-icon class="avance-icon">
                  {{ tarea.nivelAvance == 1 ? 'trending_down' : tarea.nivelAvance == 2 ? 'trending_flat' :
                  tarea.nivelAvance
                  == 3 ? 'trending_up' : '' }}
                </mat-icon>
                <span class="avance-text">
                  {{ tarea.nivelAvance == 1 ? "Baja" : tarea.nivelAvance == 2 ? "Medio" : tarea.nivelAvance == 3 ?
                  "Alto"
                  :
                  "" }}
                </span>
              </span>
            </mat-cell>
          </ng-container>


          <ng-container matColumnDef="prioridad">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              <strong>Prioridad</strong>
            </mat-header-cell>
            <mat-cell *matCellDef="let tarea">
              <span class="prioridad-container" [ngClass]="{
              'prioridad-baja': tarea.prioridad == 1,
              'prioridad-media': tarea.prioridad == 2,
              'prioridad-alta': tarea.prioridad == 3
            }">
                <mat-icon class="prioridad-icon">
                  {{ tarea.prioridad == 1 ? 'low_priority' : tarea.prioridad == 2 ? 'swap_vert' : tarea.prioridad == 3 ?
                  'priority_high' : '' }}
                </mat-icon>
                <span class="prioridad-text">
                  {{ tarea.prioridad == 1 ? "Baja" : tarea.prioridad == 2 ? "Media" : tarea.prioridad == 3 ? "Alta" : ""
                  }}
                </span>
              </span>
            </mat-cell>
          </ng-container>


          <ng-container matColumnDef="estado">
            <mat-header-cell *matHeaderCellDef mat-sort-header><strong>Estado</strong></mat-header-cell>
            <mat-cell *matCellDef="let tarea">
              <span [ngClass]="{
            'estadoPendiente': tarea.estadoTarea?.id == 1,
            'estadoEnProceso': tarea.estadoTarea?.id == 2,
            'estadoCompletada': tarea.estadoTarea?.id == 3,
            'estadoCerrada': tarea.estadoTarea?.id == 4
          }">
                {{ tarea.estadoTarea?.descripcion | titlecase }}
              </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="creadoPor">
            <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header><strong>Creado por</strong>
            </mat-header-cell>
            <mat-cell *matCellDef="let tarea">
              <app-avatar-iniciales [size]="'sm'" [nombre]='tarea.creadoPor?.nombre'
                [apellido]='tarea.creadoPor?.apellido' [activo]='tarea.creadoPor?.activo'></app-avatar-iniciales>

            </mat-cell>
          </ng-container>


          <ng-container matColumnDef="asignadoA">
            <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header><strong>Aprobado por</strong>
            </mat-header-cell>
            <mat-cell *matCellDef="let tarea">
              <app-avatar-iniciales [size]="'sm'" [nombre]='tarea.asignadoA?.nombre'
                [apellido]='tarea.asignadoA?.apellido' [activo]='tarea.asignadoA?.activo'></app-avatar-iniciales>

            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="estados">
            <mat-header-cell mat-header-cell *matHeaderCellDef><strong>Estados</strong>
            </mat-header-cell>
            <mat-cell *matCellDef="let item">
              <mat-icon class="icon-hover" [matTooltip]="'Fecha vencimiento: '+item.fechaVencimiento" *ngIf="item.fechaVencimiento"> schedule</mat-icon>
              <mat-icon  class="icon-hover" *ngIf="esHoy(item.fechaVencimiento)" [matTooltip]="'Finaliza hoy'">whatshot</mat-icon>
              <mat-icon class="icon-hover" matTooltip="Tiene expediente" *ngIf="item.expediente">gavel</mat-icon>
              <mat-icon class="icon-hover" matTooltip="Tiene notificación"
                *ngIf="item.notificado">notifications</mat-icon>
              <mat-icon class="icon-hover" matTooltip="Tiene comentario" *ngIf="item.tieneComentarios">comment</mat-icon>
            </mat-cell>

          </ng-container>

          <!-- Accion Column -->
          <ng-container matColumnDef="accion">
            <mat-header-cell mat-header-cell *matHeaderCellDef>
              <strong>Acción</strong>
            </mat-header-cell>
            <mat-cell *matCellDef="let item" class="action-link">
              <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu" >
                <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Ver, entidad: {item} })"
                  *appRoles="['Tareas.Ver']">
                  <mat-icon>visibility</mat-icon>
                  <span>Ver</span>
                </button>
                <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Modificar, entidad: {item} })"
                  *appRoles="['Tareas.Modificar']">
                  <mat-icon>edit</mat-icon>
                  <span>Editar</span>
                </button>
                <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Eliminar, entidad: {item} })"
                  *appRoles="['Tareas.Eliminar']">
                  <mat-icon>delete</mat-icon>
                  <span>Eliminar</span>
                </button>
              </mat-menu>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row matRipple *matRowDef="let row; columns: displayedColumns"></mat-row>
        </table>

        <app-sin-datos-para-mostrar [dataSource]="dataSource"></app-sin-datos-para-mostrar>

        <mat-paginator showFirstLastButtons class="paginator" *ngIf="data" [pageSize]="5"
          [pageSizeOptions]="[5, 10, 20, 50, 100, 200]"></mat-paginator>
      </div>
    </div>
  </mat-card-content>

</mat-card>
